// src/hooks/useNintendoQuestSummary.ts

import { useState, useEffect, useRef } from 'react';
import { NintendoQuestSummary } from '../lib/nintendo-quest/types';

// Hook implementation - now using centralized types
export function useNintendoQuestSummary() {
  const [data, setData] = useState<NintendoQuestSummary | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchInProgress = useRef(false);

  useEffect(() => {
    if (fetchInProgress.current) return;
    fetchInProgress.current = true;

    const fetchNintendoQuestData = async () => {
      try {
        console.log('🎮 Fetching Nintendo Quest summary...');
        
        // Create a cache-busting query parameter rounded to the nearest hour
        const now = new Date();
        now.setMinutes(0, 0, 0); // Round down to the hour
        const cacheBuster = now.getTime();

        const response = await fetch(`/nintendo-quest-summary.json?v=${cacheBuster}`);
        if (!response.ok) {
          throw new Error(`Failed to fetch Nintendo Quest summary: ${response.statusText}`);
        }

        const questData: NintendoQuestSummary = await response.json();
        console.log('🎮 Received Nintendo Quest summary:', questData);
        
        setData(questData);

      } catch (err) {
        console.error('❌ Error fetching Nintendo Quest data:', err);
        setError(err instanceof Error ? err.message : 'Unknown error');
      } finally {
        setLoading(false);
      }
    };

    fetchNintendoQuestData().finally(() => {
      fetchInProgress.current = false;
    });
  }, []);

  return { 
    data, 
    loading, 
    error
  };
}